import './background-fx';
import './i18n';
import './darkmode';
